<template>
  <div class="login-page">
    <!-- 导航栏 -->
    <HeaderComponent />
    
    <div class="login-container">
      <div class="login-content">
        <div class="login-box">
          <div class="login-header">
            <i class="fas fa-video"></i>
            <h2>弋沐登录</h2>
          </div>
          <form class="login-form" @submit.prevent="handleLogin">
            <div class="form-group">
              <label for="username">用户名</label>
              <input 
                type="text" 
                id="username" 
                v-model="form.username" 
                placeholder="请输入用户名"
                required
                autocomplete="off"
              >
            </div>
            <div class="form-group">
              <label for="password">密码</label>
              <input 
                type="password" 
                id="password" 
                v-model="form.password" 
                placeholder="请输入密码"
                required
              >
            </div>
            <div class="form-options">
              <div class="remember-me">
                <input type="checkbox" id="remember" v-model="form.remember">
                <label for="remember">记住我</label>
              </div>
              <a href="#" class="forgot-password">忘记密码？</a>
            </div>
            <button type="submit" class="btn btn-primary btn-block">登录</button>
          </form>
          <div class="login-divider">
            <span>其他登录方式</span>
          </div>
          <div class="login-social">
            <button class="social-btn weixin">
              <i class="fab fa-weixin"></i>
              <span>微信登录</span>
            </button>
            <button class="social-btn phone">
              <i class="fas fa-phone"></i>
              <span>手机号登录</span>
            </button>
          </div>
          <div class="login-footer">
            <span>还没有账号？</span>
            <router-link to="/register" class="register-link">立即注册</router-link>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 页脚 -->
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '../components/Header.vue'
import FooterComponent from '../components/Footer.vue'

export default {
  name: 'LoginView',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      form: {
        username: '',
        password: '',
        remember: false
      }
    }
  },
  methods: {
    handleLogin() {
      // 登录逻辑
      console.log('登录表单:', this.form)
      // 这里可以添加登录API调用
      alert('登录成功！')
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
.login-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.login-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.login-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
}

.login-box {
  margin: 40px auto 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 50%;
  max-width: 480px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header i {
  font-size: 48px;
  color: #667eea;
  margin-bottom: 15px;
}

.login-header h2 {
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.login-form {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 14px;
}

.remember-me {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.remember-me input {
  margin-right: 8px;
}

.forgot-password {
  color: #667eea;
  text-decoration: none;
  transition: color 0.3s;
}

.forgot-password:hover {
  text-decoration: underline;
  color: #5568d3;
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #667eea;
  color: white;
}

.btn-primary:hover {
  background-color: #5568d3;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.btn-block {
  width: 100%;
}

.login-divider {
  display: flex;
  align-items: center;
  margin: 25px 0;
  color: #999;
}

.login-divider::before,
.login-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #eee;
}

.login-divider span {
  padding: 0 15px;
  font-size: 14px;
}

.login-social {
  display: flex;
  gap: 10px;
  margin-bottom: 25px;
}

.social-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

.social-btn i {
  margin-right: 8px;
  font-size: 18px;
}

.social-btn.weixin {
  color: #07c160;
  border-color: #07c160;
}

.social-btn.phone {
  color: #1890ff;
  border-color: #1890ff;
}

.social-btn:hover {
  background-color: #f5f5f5;
  transform: translateY(-2px);
}

.login-footer {
  text-align: center;
  font-size: 14px;
  color: #666;
}

.register-link {
  color: #667eea;
  text-decoration: none;
  margin-left: 5px;
  font-weight: 500;
}

.register-link:hover {
  text-decoration: underline;
}
</style>